// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BankingBenefitsHomeViewOpenEvent
 */
export var BankingBenefitsHomeViewOpen = function (_a) {
    var origin = _a.origin;
    return ({
        name: "BankingBenefitsHome View Open",
        parameters: {
            cdf_entity: "BankingBenefitsHome",
            cdf_action: "View",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BankingBenefitsHomeTapViewAllActivityEvent
 */
export var BankingBenefitsHomeTapViewAllActivity = function () { return ({
    name: "BankingBenefitsHome Tap ViewAllActivity",
    parameters: {
        cdf_entity: "BankingBenefitsHome",
        cdf_action: "Tap",
    }
}); };
/**
 * @see BankingBenefitsHomeTapCloseEvent
 */
export var BankingBenefitsHomeTapClose = function () { return ({
    name: "BankingBenefitsHome Tap Close",
    parameters: {
        cdf_entity: "BankingBenefitsHome",
        cdf_action: "Tap",
    }
}); };
/**
 * @see BankingBenefitsHomeTapSupportLinkEvent
 */
export var BankingBenefitsHomeTapSupportLink = function () { return ({
    name: "BankingBenefitsHome Tap SupportLink",
    parameters: {
        cdf_entity: "BankingBenefitsHome",
        cdf_action: "Tap",
    }
}); };
